export default __webpack_public_path__ + "static/product_item_002-b2e6aa1a9e99ff33c32706d961c0ea4e.jpg";